import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/warning.svg';
import { Icon } from '../Icon/Icon';
export const WarningIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
